import {
  AWARDS,
  BANNERS,
  EXTRA_POINTS,
  MOVEMENTS,
  privBalanceKey,
  privMemberId,
  PUNCH_CARDS,
  REWARDS,
  setHeaders,
  setReqOpts,
  STARS_ENROLLED,
  STARS_GET,
  STARS_WINNERS,
  getFromStorage,
  privStatePicked,
} from "../utils";
// import { stars } from "./../samples";

export const getMovements = async () => await doRequest(MOVEMENTS);

export const getExtraPointsCards = async () =>
  await doRequest(EXTRA_POINTS, false, "extras");

export const getRewardsCards = async () =>
  await doRequest(REWARDS, false, "rewards");

export const getAwardsCards = async () =>
  await doRequest(AWARDS, false, "awards");

export const getStampsCards = async () =>
  await doRequest(PUNCH_CARDS, false, "stamps");

export const getBannersSlides = async () => await doRequest(BANNERS, true);

export const getStarsCards = async () =>
  await Promise.allSettled([getStarsAll(), getStarsEnrolled()]).then(
    async (results, final = {}) => {
      let temporal = results[0].value;
      let available = [];
      const now = new Date();
      if (results.every((result) => result.status === "fulfilled")) {
        // eslint-disable-next-line array-callback-return
        results[1].value.map((enrolled) => {
          // eslint-disable-next-line array-callback-return
          results[0].value.find((offer, idx) => {
            if (offer.offer_id === enrolled.offer_id) {
              temporal[idx] = { ...offer, ...enrolled };
            }
          });
        });
      }
      // eslint-disable-next-line array-callback-return
      temporal.map((offer) => {
        const { end_date, display_end_date } = offer;
        if (end_date && display_end_date) {
          const displayEndDate = new Date(display_end_date);
          if (now < displayEndDate) {
            if (checkOfferJurisdiction(offer)) {
              final[offer.offer_id] = offer;
              available.push(offer);
            }
          }
        }
      });
      const r = await Promise.allSettled(
        available.map(async (offer) => {
          const urlGetDetail = `${STARS_GET}/${offer.offer_id}`;
          const headers = setReqOpts("GET", setHeaders());
          await fetch(urlGetDetail, headers)
            .then((resp) => {
              if (resp.ok) return resp.json();
              throw new Error("Something went wrong");
            })
            .then(async (result) => {
              let tResult = { ...result };
              const { end_date, display_end_date } = tResult;
              if (end_date && display_end_date) {
                const endDate = new Date(end_date);
                const displayEndDate = new Date(display_end_date);
                if (endDate < now && now < displayEndDate) {
                  const winners = await getFocusedWinners(offer.offer_id);
                  if (winners.member_offers)
                    tResult.winners = winners.member_offers.slice(0, 5);
                  if (winners.show_position)
                    tResult.show_position = winners.show_position;
                }
              }
              final[result.offer_id] = {
                ...final[result.offer_id],
                ...tResult,
              };
            });
        })
      ).then(() => {
        return final;
      });
      return r;
      // console.log({r});
      // return stars;
    }
  );

const req = async (url, headers) => {
  headers = headers ?? setReqOpts("GET", setHeaders());
  const response = await fetch(url, headers)
    .then((fetced) => {
      if (fetced.ok) return fetced.json();
      throw new Error("Something went wrong");
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
  return response;
};

const getStarsAll = async () => await req(STARS_GET);

const getFocusedWinners = async (offerId) => {
  const memberId = localStorage.getItem(privMemberId);
  const response = await req(`${STARS_WINNERS}/${offerId}/${memberId}`);
  return response;
};

export const getAllWinners = async (offerId) =>
  await req(`${STARS_WINNERS}/${offerId}`);

const getStarsEnrolled = async () => {
  const memberId = localStorage.getItem(privMemberId);
  const headers = setReqOpts("GET", setHeaders());
  const response = await fetch(`${STARS_ENROLLED}/${memberId}`, headers)
    .then((resp) => {
      if (resp.ok) return resp.json();
      throw new Error("Something went wrong");
    })
    .then((result) => {
      return result;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
  return response;
};

const doRequest = async (path, isBannersReq = false, type = null) => {
  let url = path;
  if (!isBannersReq) url += `/${localStorage.getItem(privMemberId)}`;
  const headers = setReqOpts("GET", setHeaders());
  const response = await fetch(url, headers)
    .then((response) => {
      if (response.ok) return response.json();
      throw new Error("Something went wrong");
    })
    .then((result) => {
      let final = result;
      if (isBannersReq) {
        final = result.filter((b) => b.banner_location.includes("DASHBOARD"));
      } else if (type === "stamps") {
        final = progressEval(result);
      } else if (type === "rewards") {
        final = progressEval(result);
      } else if (type === "awards") {
        final = balanceEval(result);
      } else if (type === "extras") {
        final = dateEval(result);
      }
      const filteredSet = [];
      for (let i = 0; i < final.length; i++) {
        const element = final[i];
        if (checkOfferJurisdiction(element)) filteredSet.push(element);
      }
      return filteredSet;
    })
    .catch((err) => {
      console.error(err);
      return [];
    });
  return response;
};

const checkOfferJurisdiction = (offer, typeAllowed = []) => {
  const currState = getFromStorage(privStatePicked).value;
  const { offer_jurisdiction } = offer;

  // If offer_jurisdiction field is empty, will show in PWA
  if (!offer_jurisdiction || offer_jurisdiction.length === 0) return offer;

  if (typeof offer_jurisdiction === "object") {
    typeAllowed = offer_jurisdiction;
  } else {
    try {
      typeAllowed = JSON.parse(offer_jurisdiction);
    } catch (error) {
      console.error(error);
      return;
    }
  }

  // If offer_jurisdiction field have "N_A", wont show in PWA
  if (typeAllowed.find((e) => e === "N_A")) return;

  // If offer_jurisdiction field have the client's current state, will show in PWA
  if (typeAllowed.find((e) => e === currState)) return offer;
};

const progressEval = (result, ready = [], wip = [], toBegin = []) => {
  // eslint-disable-next-line array-callback-return
  result.map((item) => {
    if (item.available_to_redeem) ready.push(item);
    else if (item.balance > 0) wip.push(item);
    else toBegin.push(item);
  });
  const dateSorted = dateEval(toBegin);
  return [...ready, ...wip, ...dateSorted];
};

const balanceEval = (result, redeemable = [], notRedeemable = []) => {
  const balance = localStorage.getItem(privBalanceKey);
  // eslint-disable-next-line array-callback-return
  result.map((item) => {
    if (balance >= item.pay_in_points) redeemable.push(item);
    else notRedeemable.push(item);
  });
  return [...redeemable, ...notRedeemable];
};

const dateEval = (result, wDate = [], woDate = []) => {
  // eslint-disable-next-line array-callback-return
  result.map((item) => {
    if (item.valid_until && item.valid_until !== "") wDate.push(item);
    else woDate.push(item);
  });
  const withDate = wDate.sort(
    (a, b) => new Date(a.joinedDate) - new Date(b.joinedDate)
  );
  return [...withDate.reverse(), ...woDate];
};
